const webBorrowerPortalService = {
  fileName: "remoteEntry.js",
  name: "OP_WEB_BORROWER_PORTAL_V2_SERVICE",
  port: 8001,
  get url() {
    return window.location.protocol === "http:"
      ? `http://${window.location.hostname}:3001/webborrowerportalv2`
      : `${window.location.origin}/webborrowerportalv2`;
  },
  urlGlobalVariable: "OP_WEB_BORROWER_PORTAL_V2_SERVICEUrl",
  get federationConfig() {
    return `${this.name}@[window.${this.urlGlobalVariable}]/${this.fileName}`;
  }
};

const webDrawService = {
  fileName: "remoteEntry.js",
  name: "OP_WEB_DRAW_V2_SERVICE",
  port: 8002,
  get url() {
    return window.location.protocol === "http:"
      ? `http://${window.location.hostname}:3002/webdrawv2`
      : `${window.location.origin}/webdrawv2`;
  },
  urlGlobalVariable: "OP_WEB_DRAW_V2_SERVICEUrl",
  get federationConfig() {
    return `${this.name}@[window.${this.urlGlobalVariable}]/${this.fileName}`;
  }
};

const webCommonService = {
  fileName: "remoteEntry.js",
  name: "OP_WEB_COMMON_SERVICE",
  port: 3001,
  get url() {
    return window.location.protocol === "http:"
      ? `https://dev.merchantsmtg.info/webcommon`
      : `${window.location.origin}/webcommon`;
  },
  urlGlobalVariable: "OP_WEB_COMMON_SERVICEUrl",
  get federationConfig() {
    return `${this.name}@[window.${this.urlGlobalVariable}]/${this.fileName}`;
  }
};

const appraisalDashboardModule = {
  fileName: "remoteEntry.js",
  name: "appraisal_dashboard_module",
  port: 3004,
  get url() {
    return window.location.protocol === "http:"
      ? `https://dev.merchantsmtg.info/appraisal_dashboard`
      : `${window.location.origin}/appraisal_dashboard`;
  },
  urlGlobalVariable: "appraisal_dashboard_moduleUrl",
  get federationConfig() {
    return `${this.name}@[window.${this.urlGlobalVariable}]/${this.fileName}`;
  }
};

const budgetReviewModule = {
  fileName: "remoteEntry.js",
  name: "toorakBudgetReview",
  port: 3008,
  get url() {
    return window.location.protocol === "http:"
      ? `http://${window.location.hostname}:3008/budget_review_module`
      : `${window.location.origin}/budget_review_module`;
  },
  urlGlobalVariable: "toorakBudgetReviewUrl",
  get federationConfig() {
    return `${this.name}@[window.${this.urlGlobalVariable}]/${this.fileName}`;
  }
};

module.exports = {
  webBorrowerPortalService,
  webDrawService,
  webCommonService,
  appraisalDashboardModule,
  budgetReviewModule
};
